import React, { useState } from 'react'
import { HeaderDrawer } from '../../../../../../Components/CustomUi/headerGaveta'
import { BodyDrawer } from './styles'
import Tabs from '../../../../../../Components/Tabs'
import { faDroplet, faFlask, faSeedling, faSprayCan } from '@fortawesome/free-solid-svg-icons'
import { Render } from '../../../../../../Components/CustomUi/render'
import { FormDadosInsumo } from './components/dadosInsumos'
import { FormComposicao } from './components/composição'
import { FormPropriedade } from './components/propriedades'
import { FormDoseCultura } from './components/doseCultura'
import Carregando from '../../../../../../Components/CustomUi/loading'
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
interface PropsForm {
  loading: boolean
  update: number
  permissions?: ItensPerUserLogged
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  categoria_insumo: string
  setCategoria_insumo: React.Dispatch<React.SetStateAction<string>>
  categoria_insumoId: number
  setCategoria_insumoId: React.Dispatch<React.SetStateAction<number>>
  classeAgro: string
  setClasseAgro: React.Dispatch<React.SetStateAction<string>>
  classeAgroId: number
  setClasseAgroId: React.Dispatch<React.SetStateAction<number>>
  fabricante: string
  setFabricante: React.Dispatch<React.SetStateAction<string>>
  fabricanteId: number
  setFabricanteId: React.Dispatch<React.SetStateAction<number>>
  formulacao: string
  setFormulacao: React.Dispatch<React.SetStateAction<string>>
  formulacaoId: number
  setFormulacaoId: React.Dispatch<React.SetStateAction<number>>
  unidadeDose: string
  setUnidadeDose: React.Dispatch<React.SetStateAction<string>>
  unidadeDoseId: number
  setUnidadeDoseId: React.Dispatch<React.SetStateAction<number>>
  observacao: string
  setObservacao: React.Dispatch<React.SetStateAction<string>>

  //INSUMOS
  dataCatProduto: any[]
  dataCatCategoria: any[]
  dataFabricantes: any[]
  dataFormulacao: any[]
  dataUnidadeMedida: any[]
  handleChangeClasse: Function

  //COMPOSICAO
  ativo: string
  setAtivo: React.Dispatch<React.SetStateAction<string>>
  ativosId: number
  setAtivoId: React.Dispatch<React.SetStateAction<number>>
  concentracao: string
  setConcentracao: React.Dispatch<React.SetStateAction<string>>
  ativos: any[]
  setAtivos: React.Dispatch<React.SetStateAction<any[]>>
  unidadeComposicao: string
  setUnidadeComposicao: React.Dispatch<React.SetStateAction<string>>
  setUnidadeComposicaoId: React.Dispatch<React.SetStateAction<number>>
  dataAtivos: any[]
  dataUnidadeMedidaComposicao: any[]
  adicionarAtivos: Function
  handleRemoveAtivo: Function

  //PROPRIEDADE
  dataCaldas: any[]
  dataPlantas: any[]
  caldasSelecionadas: { descr: string; id: number; key?: number }[]
  setCaldasSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  gotaSelecionadas: { descr: string; id: number; key?: number }[]
  setGotaSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  folhaSelecionadas: { descr: string; id: number; key?: number }[]
  setFolhaSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  dentroSelecionadas: { descr: string; id: number; key?: number }[]
  setDentroSelecionadas: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  acaoPhSelecionadas: string
  setAcaoPhSelecionadas: React.Dispatch<React.SetStateAction<string>>
  setAcaoPhSelecionadasId: React.Dispatch<React.SetStateAction<number>>

  //CULTURA
  dataCulturas: any[]
  cultura: string
  setCultura: React.Dispatch<React.SetStateAction<string>>
  setCulturaId: React.Dispatch<React.SetStateAction<number>>
  valor_dose: string
  setValor_dose: React.Dispatch<React.SetStateAction<string>>
  doses_culturas_adicionados: any[]
   setDoses_culturas_adicionados: React.Dispatch<React.SetStateAction<any[]>>
  adicionar_dose: Function
  remover_cultura_dose: Function
  fakeLoading: boolean

}

export const FormularioAdjuvantes: React.FC<PropsForm> = ({
  loading,
  update,
  permissions,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  ativo,
  ativos,
  ativosId,
  categoria_insumo,
  categoria_insumoId,
  classeAgro,
  classeAgroId,
  concentracao,
  dataAtivos,
  dataCatCategoria,
  dataCatProduto,
  dataFabricantes,
  dataFormulacao,
  dataUnidadeMedida,
  fabricante,
  fabricanteId,
  formulacao,
  formulacaoId,
  handleChangeClasse,
  nome,
  observacao,
  setAtivo,
  setAtivoId,
  setAtivos,
  setCategoria_insumo,
  setCategoria_insumoId,
  setClasseAgro,
  setClasseAgroId,
  setConcentracao,
  setFabricante,
  setFabricanteId,
  setFormulacao,
  setFormulacaoId,
  setNome,
  setObservacao,
  setUnidadeDose,
  setUnidadeDoseId,
  unidadeDose,
  adicionarAtivos,
  handleRemoveAtivo,
  dataCaldas,
  dataPlantas,
  caldasSelecionadas,
  setCaldasSelecionadas,
  gotaSelecionadas,
  setGotaSelecionadas,
  folhaSelecionadas,
  setFolhaSelecionadas,
  dentroSelecionadas,
  setDentroSelecionadas,
  acaoPhSelecionadas,
  setAcaoPhSelecionadas,
  setAcaoPhSelecionadasId,
  adicionar_dose,
  cultura,
  dataCulturas,
  doses_culturas_adicionados,
  setDoses_culturas_adicionados,
  dataUnidadeMedidaComposicao,
  setCultura,
  setCulturaId,
  setValor_dose,
  valor_dose,
  unidadeComposicao,
  setUnidadeComposicao,
  setUnidadeComposicaoId,
  remover_cultura_dose,
  fakeLoading,
}) => {
  const [confirmar_exclusao_composicao, setConfirmar_exclusao_composicao] = useState<boolean>(false)
  const [id_item_atual_composicao, setId_item_atual_composicao] = useState<number>(null)
  const [nome_item_atual_composicao, setNome_item_atual_composicao] = useState<string>('')
  const [fake_loading_composicao, setFake_loading_composicao] = useState<boolean>(false)
  const [updateConcentracao, setUpdateConcentracao] = useState(null)

  const handleChangeMask = (data) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')
    return area
  }

  const editarAtivo = (uid) => {
    const dados = [...ativos]
    dados.forEach((data) => {
      if (data.uid === uid) {
        data.editable = true
      } else {
        data.editable = false
      }
    })
    setAtivos(dados)
  }

  const salvarAtivo = (cod) => {
    const dados = [...ativos]
    dados.forEach((data) => {
      if (data.cod === cod) {
        data.concentracao = updateConcentracao
      }
      data.editable = false
    })

    setAtivos(dados)
  }

  const mudarConcentracao = (concen, uid) => {
    let concentracao = handleChangeMask(concen)
    const dados = [...ativos]
    let temp = []
    dados.forEach((data) => {
      if (data.uid === uid) {
        data.concentracao = concentracao
        setUpdateConcentracao(concentracao)
      }
      temp = [...temp, data]

      return temp
    })

    setAtivos(temp)
  }

  return (
    <div>
      <HeaderDrawer>
        <div>{update > 0 ? 'Atualizar adjuvante' : 'Cadastrar adjuvante'}</div>
      </HeaderDrawer>
      <BodyDrawer>
        <Tabs
          tabs={[
            { descricao: 'Dados do adjuvante', icone: faSeedling },
            { descricao: 'Composição', icone: faFlask },
            { descricao: 'Propriedades', icone: faSprayCan },
            { descricao: 'Dose cultura', icone: faDroplet },
          ]}
          selecionado={tab_selecionar_atual}
          trackWidth={187}
          onChange={setTab_selecionar_atual}
        />
        <Render condition={loading === false}>
          <Render condition={tab_selecionar_atual === 'Dados do adjuvante'}>
            <FormDadosInsumo
              nome={nome}
              setNome={setNome}
              classeAgro={classeAgro}
              setClasseAgro={setClasseAgro}
              fabricante={fabricante}
              setFabricante={setFabricante}
              setFabricanteId={setFabricanteId}
              observacao={observacao}
              setObservacao={setObservacao}
              dataCatProduto={dataCatProduto}
              dataCatCategoria={dataCatCategoria}
              dataFabricantes={dataFabricantes}
              handleChangeClasse={handleChangeClasse}
            />
          </Render>
          <Render condition={tab_selecionar_atual === 'Composição'}>
            <FormComposicao
              dataAtivos={dataAtivos}
              dataUnidadeMedidaComposicao={dataUnidadeMedidaComposicao}
              ativo={ativo}
              setAtivo={setAtivo}
              ativosId={ativosId}
              setAtivoId={setAtivoId}
              concentracao={concentracao}
              setConcentracao={setConcentracao}
              adicionarAtivos={adicionarAtivos}
              ativos={ativos}
              salvarAtivo={salvarAtivo}
              editarAtivo={editarAtivo}
              mudarConcentracao={mudarConcentracao}
              unidadeComposicao={unidadeComposicao}
              setUnidadeComposicao={setUnidadeComposicao}
              setUnidadeComposicaoId={setUnidadeComposicaoId}
              confirmar_exclusao={confirmar_exclusao_composicao}
              setConfirmar_exclusao={setConfirmar_exclusao_composicao}
              id_item_atual={id_item_atual_composicao}
              setId_item_atual={setId_item_atual_composicao}
              nome_item_atual={nome_item_atual_composicao}
              setNome_item_atual={setNome_item_atual_composicao}
              fake_loading={fake_loading_composicao}
              setFake_loading={setFake_loading_composicao}
              handleRemoveAtivo={handleRemoveAtivo}
              permissions={permissions}
            />
          </Render>
          <Render condition={tab_selecionar_atual === 'Propriedades'}>
            <FormPropriedade
              dataCaldas={dataCaldas}
              dataPlantas={dataPlantas}
              caldasSelecionadas={caldasSelecionadas}
              setCaldasSelecionadas={setCaldasSelecionadas}
              acaoPhSelecionadas={acaoPhSelecionadas}
              setAcaoPhSelecionadas={setAcaoPhSelecionadas}
              setAcaoPhSelecionadasId={setAcaoPhSelecionadasId}
              gotaSelecionadas={gotaSelecionadas}
              setGotaSelecionadas={setGotaSelecionadas}
              folhaSelecionadas={folhaSelecionadas}
              setFolhaSelecionadas={setFolhaSelecionadas}
              dentroSelecionadas={dentroSelecionadas}
              setDentroSelecionadas={setDentroSelecionadas}
            />
          </Render>
          <Render condition={tab_selecionar_atual === 'Dose cultura'}>
            <FormDoseCultura
              dataCulturas={dataCulturas}
              cultura={cultura}
              setCultura={setCultura}
              setCulturaId={setCulturaId}
              valor_dose={valor_dose}
              setValor_dose={setValor_dose}
              doses_culturas_adicionados={doses_culturas_adicionados}
              setDoses_culturas_adicionados={setDoses_culturas_adicionados}
              adicionar_dose={adicionar_dose}
              remover_cultura_dose={remover_cultura_dose}
              fakeLoading={fakeLoading}
              unidadeDose={unidadeDose}
              setUnidadeDose={setUnidadeDose}
              setUnidadeDoseId={setUnidadeDoseId}
              dataUnidadeMedida={dataUnidadeMedida}
            />
          </Render>
        </Render>
        <Render condition={loading}>
          <Carregando animation legenda='Carregando...' height={600} justifyContent='center' />
        </Render>
      </BodyDrawer>
    </div>
  )
}
